import React, { useState } from 'react';
import './RegisterPage.css';
import { SectionWrap } from '../../Components';
import { Navigate } from 'react-router-dom';
import axios from 'axios';

function RegisterPage() {
  const [redirect, setRedirect] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  // const apiUrl = 'http://localhost/server/testServer'
  const apiUrl = 'https://www.albarede.com/server'

  async function handleLogin(e) {
    e.preventDefault();
    setError('');
    
    try {
      const formData = new FormData();
      formData.append('username', username.trim());
      formData.append('password', password.trim());

      const response = await axios.post(`${apiUrl}/users.php`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      if (response.data.status === 'success') {
        setRedirect(true);
        localStorage.setItem('isLoggedIn', 'true');
      } else {
        setError(response.data.message || 'اسم المستخدم أو كلمة المرور غير صحيحة');
      }
    } catch (err) {
      setError('حدث خطأ أثناء الاتصال بالخادم. يرجى المحاولة لاحقاً.');
      console.error('Login error:', err);
    }
  }

  if (redirect) {
    return <Navigate to="/" />;
  }

  return (
    <div className="login">
      <SectionWrap>
        <h2>تسجيل الدخول</h2>
        {error && <div className="error-message">{error}</div>}
        <form onSubmit={handleLogin} className="register">
          <div className="form-group">
            <label>اسم المستخدم:</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              autoFocus
            />
          </div>
          <div className="form-group">
            <label>كلمة المرور:</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="login-btn">تسجيل الدخول</button>
        </form>
      </SectionWrap>
    </div>
  );
}

export default RegisterPage;
